import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  template: ''
})
export abstract class FilterDisplayComponent {
  showSideSheetRight: Subject<boolean>;

  filtersOpened: boolean = false;

  protected constructor() {
    this.showSideSheetRight = new Subject<boolean>();
  }

  openFiltersModal(): void {
    this.filtersOpened = true;
    this.showSideSheetRight.next(true);

  }

  closeFiltersModal(): void {
    this.filtersOpened = false;
    this.showSideSheetRight.next(false);
  }
}
